// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfn_a bhm_wj bhm_ss bhm_xl"};